module.exports = __webpack_public_path__ + "static/img/3.6d75327.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fuwu/3.png
// module id = UxgR
// module chunks = 1